var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticStyle:{"position":"absolute","right":"5px","top":"5px","z-index":"10"},attrs:{"color":"white","size":"22"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-microphone"+_vm._s(_vm.haveAudio ? "" : "-off")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }